// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminAppointmentMethod } from './admin-appointment-method';
import { AdminContact } from './admin-contact';
import { Asset } from './asset';
import { Bank } from './bank';
import { Bankrupt } from './bankrupt';
import { Contact } from './contact';
import { Contribution } from './contribution';
import { CounterpartyAddress } from './counterparty-address';
import { CounterpartyCounterpartyType } from './counterparty-counterparty-type';
import { CounterpartyDatum } from './counterparty-datum';
import { CounterpartyNumber } from './counterparty-number';
import { CounterpartyType } from './counterparty-type';
import { Creditor } from './creditor';
import { DocumentRecipient } from './document-recipient';
import { IndustryType } from './industry-type';
import { Insurer } from './insurer';
import { Liability } from './liability';
import { MergeTemplate } from './merge-template';
import { Security } from './security';
import { SubEntry } from './sub-entry';
import { SuperFund } from './super-fund';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Counterparty extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyId!: number;
  abn?: string;
  accountName?: string;
  accountNo?: string;
  altAddress?: string;
  altPayee?: string;
  altReference?: string;
  bankAddress?: string;
  bankId?: number;
  bankName?: string;
  bsb?: string;
  contextId?: number;
  counterpartyTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  exFlags?: number;
  firstName?: string;
  flags?: number;
  industryTypeId?: number;
  isIndividual!: boolean;
  lastName?: string;
  mchildCount!: number;
  muid?: string;
  name!: string;
  parentCounterpartyId?: number;
  pmuid?: string;
  portalTs?: string;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  status!: number;
  title?: string;
  ts!: string;
  type?: number;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webData?: number;
  webFlags?: number;
  adminAppointmentMethods!: AdminAppointmentMethod[];
  adminContacts!: AdminContact[];
  assets!: Asset[];
  bank!: Bank;
  bankrupts!: Bankrupt[];
  contacts!: Contact[];
  contributions!: Contribution[];
  counterpartyAddresses!: CounterpartyAddress[];
  counterpartyCounterpartyTypes!: CounterpartyCounterpartyType[];
  counterpartyData!: CounterpartyDatum[];
  counterpartyNumbers!: CounterpartyNumber[];
  counterpartyType!: CounterpartyType;
  creditorCounterparties!: Creditor[];
  creditorSubCounterparties!: Creditor[];
  documentRecipients!: DocumentRecipient[];
  industryType!: IndustryType;
  insurers!: Insurer[];
  inverseParentCounterparty!: Counterparty[];
  liabilities!: Liability[];
  mergeTemplates!: MergeTemplate[];
  parentCounterparty!: Counterparty;
  securities!: Security[];
  subEntries!: SubEntry[];
  superFunds!: SuperFund[];
}

